'use client';
import React, { useState } from 'react';
import { MODULES, LESSONS } from '@/lib/mockData';
import ModuleCard from './ModuleCard';

const GRADE_FILTERS = ['All Grades', 'Elementary', 'Middle School', 'High School'];

export default function ModulesGrid() {
  const [gradeFilter, setGradeFilter] = useState('All Grades');

  const filtered = MODULES?.filter(
    (m) => gradeFilter === 'All Grades' || m?.gradeBand === gradeFilter || m?.gradeBand === 'All Grades'
  );

  return (
    <div className="bg-stone-50 min-h-screen py-10">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 2xl:px-16">
        {/* Grade filter */}
        <div className="flex items-center gap-2 mb-8 overflow-x-auto scrollbar-hide pb-1">
          {GRADE_FILTERS?.map((grade) => (
            <button
              key={`grade-filter-${grade}`}
              onClick={() => setGradeFilter(grade)}
              className={`px-4 py-2 rounded-xl text-sm font-medium whitespace-nowrap transition-all duration-150 active:scale-95 ${
                gradeFilter === grade
                  ? 'bg-primary-500 text-white shadow-sm'
                  : 'bg-white text-stone-600 border border-stone-200 hover:border-primary-300 hover:text-primary-600'
              }`}
            >
              {grade}
            </button>
          ))}
        </div>

        {/* Modules grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
          {filtered?.map((module) => {
            const moduleLessons = LESSONS?.filter((l) => module.lessons?.includes(l?.id));
            return (
              <ModuleCard key={module.id} module={module} lessons={moduleLessons} />
            );
          })}
        </div>
      </div>
    </div>
  );
}